import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { BrowserInactivityService } from "src/app/service/browser-inactivity.service";
import { TimeoutStorageService } from "src/app/shared/timeout/timeout-storage.service";

@Component({
  standalone: false,
  selector: "app-session-timeout",
  templateUrl: "./session-timeout.component.html",
  styleUrls: ["./session-timeout.component.scss"],
})
export class SessionTimeoutComponent implements OnInit {
  idleTimeout: number = 0;
  errorMessage = ''
  constructor(private browserInactivityService: BrowserInactivityService,
    private location: Location,
    private timeoutStorageService: TimeoutStorageService) {
    browserInactivityService.onTimeoutWarning().subscribe((countdown) => {
      this.errorMessage = 'You will time out in ' + countdown + ' seconds.'
      // console.log(this.idleState);
    });
  }

  ngOnInit() {
    if (this.timeoutStorageService.loadIdleTimeout()) {
      this.idleTimeout = parseInt(this.timeoutStorageService.loadIdleTimeout()) / 2;
    }
  }

  reAuthenticate() {
    // this.childModal.hide();
    this.browserInactivityService.watch();
    this.location.back();
  }

}

